/**
 * Builder state patch when the user picks a different visualization.
 * Keeps KPI, trend, and breakdown modes from carrying stale fields.
 */
export function patchForChartTypeChange(state = {}, nextChartType) {
  if (!nextChartType || nextChartType === state.chartType) {
    return {};
  }

  const patch = { chartType: nextChartType };
  const previousDimension = state.dimension || '';
  const preset = state.dateRange?.preset;
  if (state.dateRange) {
    patch.dateRange = state.dateRange;
  }

  if (nextChartType === 'number') {
    patch.dimension = '';
    patch.includedValues = [];
    patch.aggregation = 'count';
    patch.measureField = '';
    patch.filters = (state.filters || []).filter((item) => item.field !== previousDimension);
    return patch;
  }

  if (nextChartType === 'line') {
    patch.dimension = '';
    patch.includedValues = [];
    const keepChosenRange = state.dataset === 'whatsapp_templates';
    if (!keepChosenRange && (!preset || preset === 'all_time')) {
      patch.dateRange = { preset: 'last_30_days' };
    }
    return patch;
  }

  if (state.chartType === 'number') {
    patch.dimension = '';
    patch.includedValues = [];
  }

  return patch;
}
